import styles from "./SampleListItem.module.css";
import config from "environment";
import PropTypes from "prop-types";
import { ProductTag } from "shared/components/ProductTag/ProductTag";
import { Heart } from "shared/components/Heart/Heart";
import { Button } from "@wwg/ui";
import dayjs from "dayjs";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { samplePropType } from "shared/propTypes";
import { SampleEdit } from "../../SampleEdit/SampleEdit";
import { Modal } from "shared/components/Modal/Modal";
import { ModalContent } from "shared/components/Modal/Modal";
import { ModalControls } from "shared/components/Modal/Modal";
import { ModalHeader } from "shared/components/Modal/Modal";

export function SampleListItem({ sample, onEditSubmit, onDelete }) {
  const { id, tags, liked, date, note } = sample;
  const { t } = useTranslation();
  const formattedDate = useMemo(
    () => dayjs(date).format(config.dateFormat),
    [date]
  );

  const [confirmingDelete, setConfirmingDelete] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  if (isEditing) {
    return (
      <>
        <tr style={{ verticalAlign: "top" }}>
          <td colSpan={3} className={styles.editing}>
            <SampleEdit
              sample={sample}
              onCancel={() => {
                setIsEditing(false);
              }}
              onSubmit={(updated) => {
                onEditSubmit(updated);
                setIsEditing(false);
              }}
            />
          </td>
        </tr>
        <tr>
          <td colSpan={3}>
            <div className={styles.divider} />
          </td>
        </tr>
      </>
    );
  }

  return (
    <>
      <tr style={{ verticalAlign: "top" }}>
        <td className={styles.tagsColumn}>
          <ul className={styles.tags}>
            {tags.map((tag) => (
              <li key={tag}>
                <ProductTag name={tag} />
              </li>
            ))}
          </ul>

          <div className={styles.date}>{formattedDate}</div>

          {note && (
            <div className={styles.notes}>
              <span className={styles.notesLabel}>
                {t("labels.sampleNote")}:{" "}
              </span>
              {note}
            </div>
          )}
        </td>
        <td className={styles.lovedColumn}>
          <div className={styles.loved}>
            <Heart id={`heart-${id}`} isChecked={liked} />
          </div>
        </td>
        <td className={styles.buttonsColumn}>
          <Button
            buttonStyle="hollow"
            onClick={() => {
              setIsEditing(true);
            }}
          >
            {t("buttons.edit")}
          </Button>

          <Button
            buttonStyle="danger"
            onClick={() => {
              setConfirmingDelete(true);
            }}
          >
            {t("buttons.delete")}
          </Button>
        </td>
      </tr>

      <tr>
        <td colSpan={3}>
          <div className={styles.divider} />
        </td>
      </tr>

      <Modal isOpen={confirmingDelete}>
        <ModalContent>
          <p>{t("labels.sampleDeleteConfirm")}</p>
        </ModalContent>
        <ModalControls>
          <Button
            buttonStyle="hollow"
            onClick={() => {
              setConfirmingDelete(false);
            }}
          >
            {t("buttons.cancel")}
          </Button>
          <Button
            buttonStyle="danger"
            onClick={() => {
              onDelete(sample);
              setConfirmingDelete(false);
            }}
          >
            {t("buttons.delete")}
          </Button>
        </ModalControls>
      </Modal>
    </>
  );
}

SampleListItem.propTypes = {
  sample: samplePropType.isRequired,
};
